export { default } from './RightSidebarPromMat';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/PromotionalMaterials/RightSidebarPromMat/index.js